import TablePagination from '@amzn/awsui-components-react/polaris/table-pagination';
import {
  Badge,
  Button,
  Checkbox,
  Table,
  TableContentSelector,
  TablePreferences,
  TablePropertyFiltering,
  TableSorting,
} from 'AWS-UI-Components-React';
import React from 'react';
import Select from 'react-select';
import { downloadFile, toDownloadFormat } from '../../../utilities';
import { getChannelMappingFilters } from './channel_mapping_utils';
import { CMReviewChanges } from './cm_review_changes';
import { CMAddMapping } from './cm_add_mapping';

const tablePageSize = 30;

const hiddenColumns = ['comments', 'ignored'];

export class ChannelMappingTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reviewChangesScreen: { visible: false, comment: 'Changes by user: ' + this.props.user + ' at ' + new Date().toUTCString() },
      addMappingScreen: { visible: false },
      modifiedChannelMappingsById: {},
      stagedChannelMappings: {},
      latestChannelMappingsById: {},
      latestChannelMappings: [],
    }
  }

  getColumnDefinitions = () => {
    return [
      {
        id: 'cognosChannelType',
        header: this.formatHeader('Cognos Channel Type'),
        columnName: 'Cognos Channel Type',
        minWidth: '90px',
        cell: (item) => {
          return (
            <span>
              {item.cognosChannelType} {this.getBadges(item)}
            </span>
          );
        },
      },
      {
        id: 'channelDescription',
        header: this.formatHeader('Cognos Channel Description'),
        columnName: 'Cognos Channel Description',
        minWidth: '180px',
        cell: (item) => item.channelDescription,
      },
      {
        id: 'cognosParentChannel',
        header: this.formatHeader('Cognos Parent Channel'),
        columnName: 'Cognos Parent Channel',
        minWidth: '90px',
        cell: (item) => item.cognosParentChannel,
      },
      {
        id: 'cognosChannel',
        header: this.formatHeader('Cognos Channel'),
        columnName: 'Cognos Channel',
        minWidth: '90px',
        cell: (item) => item.cognosChannel,
      },
      {
        id: 'groupCode',
        header: this.formatHeader('Cognos Group Code'),
        columnName: 'Cognos Group Code',
        minWidth: '90px',
        cell: (item) => item.groupCode == null ? "N/A" : item.groupCode,
      },
      {
        id: 'hcpMerchantChannel',
        header: this.formatHeader('HCP Merchant Channel'),
        columnName: 'HCP Merchant Channel',
        minWidth: '180px',
        cell: (item) => this.channelSelectionComponent(item),
      },
      {
        id: 'hcpChannelType',
        header: this.formatHeader('HCP Channel Type'),
        columnName: 'HCP Channel Type',
        minWidth: '130px',
        cell: (item) => this.channelTypeSelectionComponent(item),
      },
      {
        id: 'marketplaceId',
        header: this.formatHeader('Marketplace Id'),
        columnName: 'Derived Marketplace Id',
        minWidth: '50px',
        cell: (item) => item.derivedMarketplaceId,
      },
      {
        id: 'marketplaceName',
        header: this.formatHeader('Marketplace Name'),
        columnName: 'Marketplace Name',
        minWidth: '50px',
        cell: (item) => item.marketplaceName,
      },
      {
        id: 'excluded',
        header: this.formatHeader('Cognos Excluded'),
        columnName: 'Cognos Excluded',
        minWidth: '50px',
        cell: (item) => (
          <Checkbox
            checked={item.excluded || false}
            controlId={item.id}
            onChange={() => this.onExcludedChange(event, item)}
            disabled={this.props.readOnly}
          />
        )
      },
      {
        id: 'hcpExcluded',
        header: this.formatHeader('HCP Excluded'),
        columnName: 'HCP Excluded',
        minWidth: '50px',
        cell: (item) => (
          <Checkbox
            checked={item.hcpExcluded || false}
            controlId={item.id}
            onChange={() => this.onHCPExcludedChange(event, item)}
            disabled={this.props.readOnly}
          />
        )
      },
      {
        id: 'ignored',
        header: this.formatHeader('Ignored'),
        columnName: 'Ignored',
        minWidth: '50px',
        cell: (item) => (
          <Checkbox
            checked={item.ignored || false}
            controlId={item.id}
            onChange={() => this.onIgnoredChange(event, item)}
            disabled={this.props.readOnly}
          />
        )
      },
      {
        id: 'comments',
        header: this.formatHeader('Comments'),
        columnName: 'Comments',
        cell: (item) => item.comments,
      },
    ];
  };

  formatHeader = (header) => {
    if (header.includes("Cognos")) {
      return this.formatStyle(header, "green");
    } else if (header.includes("HCP")) {
      return this.formatStyle(header, "crimson");
    } else {
      return header;
    }
  };

  formatStyle = (header, color) => {
    return <span style={{color: color}}> {header} </span>;
  };

  onClickDownloadData = (columnDefinitions, channelMappings) => {
    columnDefinitions.map((def) => def.header = def.columnName);
    const data = toDownloadFormat(columnDefinitions, channelMappings);
    downloadFile(data, 'Channel_Mappings.xls');
  };

  getBadges = (channelMapping) => {
    let badges = [];
    if (isNaN(channelMapping.version)) {
      badges.push(
        <Badge key={`$STAGED_${channelMapping.id}`} color={'blue'}>
          Staged
        </Badge>
      );
    }

    return badges.map((badge) => <span key={badge.key}>{badge} </span>);
  };

  channelSelectionComponent = (channelMapping) => {
    const selected = this.props.dropdownOptions.hcpChannelOptions.find((option) => option.value === channelMapping.hcpMerchantChannel);
    return (
      <div key={`CHANNEL_SELECTION_${channelMapping.cognosChannelType}_${channelMapping.hcpMerchantChannel}`}>
        <Select
          options={this.props.dropdownOptions.hcpChannelOptions}
          defaultValue={selected}
          onChange={(selectedOption) => this.onChannelSelectionChange(selectedOption, channelMapping)}
          isMulti={false}
          isDisabled={this.props.readOnly}
        />
      </div>
    );
  };

  channelTypeSelectionComponent = (channelMapping) => {
    const selected = this.props.dropdownOptions.hcpChannelTypeOptions.find((option) => option.value === channelMapping.hcpChannelType);
    return (
      <div key={`CHANNEL_TYPE_SELECTION_${channelMapping.cognosChannelType}_${channelMapping.hcpChannelType}`}>
        <Select
          options={this.props.dropdownOptions.hcpChannelTypeOptions}
          defaultValue={selected}
          onChange={(selectedOption) => this.onChannelTypeSelectionChange(selectedOption, channelMapping)}
          isMulti={false}
          isDisabled={this.props.readOnly}
        />
      </div>
    );
  };

  onChannelTypeSelectionChange = (selectedOption, channelMapping) => {
    const originalChannelMapping = this.getOriginalChannelMapping(channelMapping);
    const modifiedChannelMapping = this.getModifiedChannelMapping(channelMapping);

    modifiedChannelMapping.hcpChannelType = selectedOption.value;
    modifiedChannelMapping.comments = this.state.reviewChangesScreen.comment;

    this.handleChannelMappingModification(originalChannelMapping, modifiedChannelMapping);
  };

  onChannelSelectionChange = (selectedOption, channelMapping) => {
    const originalChannelMapping = this.getOriginalChannelMapping(channelMapping);
    const modifiedChannelMapping = this.getModifiedChannelMapping(channelMapping);

    modifiedChannelMapping.hcpMerchantChannel = selectedOption.value;
    modifiedChannelMapping.phoenixChannel = selectedOption.value;
    modifiedChannelMapping.comments = this.state.reviewChangesScreen.comment;

    this.handleChannelMappingModification(originalChannelMapping, modifiedChannelMapping);
  };

  getOriginalChannelMapping = (channelMapping) => {
    return this.props.channelMappingsById[channelMapping.id];
  };

  getModifiedChannelMapping = (channelMapping) => {
    const { id } = channelMapping;
    return this.state.modifiedChannelMappingsById[id]
           ? { ...this.state.modifiedChannelMappingsById[id] }
           : { ...channelMapping };
  };

  onExcludedChange = (event, channelMapping) => {
    const originalChannelMapping = this.getOriginalChannelMapping(channelMapping);
    const modifiedChannelMapping = this.getModifiedChannelMapping(channelMapping);
    modifiedChannelMapping.excluded = Boolean(event.detail.checked);
    modifiedChannelMapping.comments = this.state.reviewChangesScreen.comment;
    channelMapping.excluded = Boolean(event.detail.checked);

    this.handleChannelMappingModification(originalChannelMapping, modifiedChannelMapping);
  };

  onHCPExcludedChange = (event, channelMapping) => {
    const originalChannelMapping = this.getOriginalChannelMapping(channelMapping);
    const modifiedChannelMapping = this.getModifiedChannelMapping(channelMapping);
    modifiedChannelMapping.hcpExcluded = Boolean(event.detail.checked);
    modifiedChannelMapping.comments = this.state.reviewChangesScreen.comment;
    channelMapping.hcpExcluded = Boolean(event.detail.checked);

    this.handleChannelMappingModification(originalChannelMapping, modifiedChannelMapping);
  };

  onIgnoredChange = (event, channelMapping) => {
    const originalChannelMapping = this.getOriginalChannelMapping(channelMapping);
    const modifiedChannelMapping = this.getModifiedChannelMapping(channelMapping);
    modifiedChannelMapping.ignored = Boolean(event.detail.checked);
    modifiedChannelMapping.comments = this.state.reviewChangesScreen.comment;
    channelMapping.ignored = Boolean(event.detail.checked);

    this.handleChannelMappingModification(originalChannelMapping, modifiedChannelMapping);
  };

  reviewChangesScreenDismiss = () => {
    this.props.onScreenDismiss();
    this.setState({
                    reviewChangesScreen: {
                      visible: false,
                      stagedChannelMappings: null,
                      latestChannelMappingsById: null,
                      successScreenMessage: null,
                      errorScreenMessage: null,
                    },
                  });
  };

  addMappingScreenDismiss = () => {
    this.props.onScreenDismiss();
    this.setState({
                    addMappingScreen: {
                      visible: false,
                      stagedChannelMappings: null,
                      latestChannelMappingsById: null,
                      successScreenMessage: null,
                      errorScreenMessage: null,
                    },
                  });
  };

  hasStagedChanges = () => {
    const { channelMappingsById } = this.props;
    for (let id of Object.keys(channelMappingsById || {})) {
      if (isNaN(channelMappingsById[id].version)) {
        return true;
      }
    }

    return false;
  };

  getStagedChannelMappings = () => {
    const { channelMappingsById } = this.props;
    let stagedChannelMappings = [];
    for (let id of Object.keys(channelMappingsById || {})) {
      if (isNaN(channelMappingsById[id].version)) {
        stagedChannelMappings.push(channelMappingsById[id]);
      }
    }

    return stagedChannelMappings.reduce((obj, item) => ({...obj, [item['id']]: item}), {});;
  };

  onClickReviewPublishChanges = () => {
    this.props.refreshChannelMapping();
    const { channelMappingsById } = this.props;
    this.setState({
                    reviewChangesScreen: {
                      visible: true,
                      stagedChannelMappings: this.getStagedChannelMappings(),
                      latestChannelMappingsById: channelMappingsById,
                      comment: 'Changes by user: ' + this.props.user + ' at ' + new Date().toUTCString(),
                    },
                  });
  };

  handleChannelMappingModification = (originalChannelMapping, modifiedChannelMapping) => {
    const { id } = originalChannelMapping;
    let modifiedChannelMappingsById = {
      ...this.state.modifiedChannelMappingsById,
      [id]: modifiedChannelMapping,
    };

    this.stageChannelMappingChanges(modifiedChannelMappingsById, this.props.channelMappingsById);
    this.setState({ modifiedChannelMappingsById: {} });
  };

  unstageChannelMappingChanges = (selectedChannelMappingIds, latestChannelMappingsById) => {
    const { unstageChannelMappingChanges, channelMappingsById } = this.props;

    unstageChannelMappingChanges(selectedChannelMappingIds, latestChannelMappingsById);

    this.setState({
                    reviewChangesScreen: {
                      visible: this.state.reviewChangesScreen.visible,
                      stagedChannelMappings: this.getStagedChannelMappings(),
                      latestChannelMappingsById: channelMappingsById,
                      latestChannelMappings: Object.values(channelMappingsById),
                      modifiedChannelMappingsById: {},
                    },
                  });
  };

  stageChannelMappingChanges = (selectedChannelMappingIds, latestChannelMappingsById) => {
    const { stageChannelMappingChanges, channelMappingsById } = this.props;

    stageChannelMappingChanges(selectedChannelMappingIds, latestChannelMappingsById);

    this.setState({
                    reviewChangesScreen: {
                      visible: this.state.reviewChangesScreen.visible,
                      stagedChannelMappings: this.getStagedChannelMappings(),
                      latestChannelMappingsById: channelMappingsById,
                      modifiedChannelMappingsById: {},
                    },
                  });
  };

  addChannelMappings = (selectedChannelMappingIds, latestChannelMappingsById) => {
    const { addChannelMappings, channelMappingsById } = this.props;

    addChannelMappings(selectedChannelMappingIds, latestChannelMappingsById);

    this.setState({
                    reviewChangesScreen: {
                      visible: this.state.reviewChangesScreen.visible,
                      stagedChannelMappings: this.getStagedChannelMappings(),
                      latestChannelMappingsById: channelMappingsById,
                      modifiedChannelMappingsById: {},
                    },
                  });
  };

  publishChannelMappingChanges = (stagedChannelMappings, latestChannelMappingsById) => {
    const { publishChannelMappingChanges, channelMappingsById } = this.props;

    publishChannelMappingChanges(stagedChannelMappings, latestChannelMappingsById);

    this.setState({
                    reviewChangesScreen: {
                      visible: this.state.reviewChangesScreen.visible,
                      stagedChannelMappings: this.getStagedChannelMappings(),
                      latestChannelMappingsById: channelMappingsById,
                      latestChannelMappings: Object.values(channelMappingsById),
                      modifiedChannelMappingsById: {},
                    },
                  });
  };

  tableContentSelectorOptions = (columnDefinitions) => {
    return [
      {
        options: columnDefinitions.map((entry) => {
          return {
            id: entry.id,
            label: entry.columnName,
            visible: !hiddenColumns.includes(entry.id),
          };
        }),
        label: '',
      },
    ];
  };

  onAddChannelMapping = () => {
    this.props.refreshChannelMapping();
    this.setState({
                    addMappingScreen: {
                      visible: true,
                      stagedChannelMappings: this.getStagedChannelMappings(),
                      latestChannelMappingsById: this.props.channelMappingsById,
                      comment: 'Changes by user: ' + this.props.user + ' at ' + new Date().toUTCString(),
                      username: this.props.user,
                    },
                  });
  };

  render() {
    const { errorScreenMessage, successScreenMessage , channelMappings } = this.props;
    const columnDefinitions = this.getColumnDefinitions();
    const { reviewChangesScreen, addMappingScreen, latestChannelMappings } = this.state;

    return (
      <div>
        <Table
          columnDefinitions={ columnDefinitions }
          items={ latestChannelMappings.length ? latestChannelMappings : channelMappings }
          header={
            channelMappings &&
            <div className="awsui-util-action-stripe">
              <div className="awsui-util-action-stripe-title">
                <h2>Channel Mappings <span className="awsui-util-header-counter">({ channelMappings.length })</span></h2>
              </div>
              <div className="awsui-util-action-stripe-group">
                { !this.props.readOnly && (
                  <Button
                    text="Review/Publish"
                    variant="primary"
                    onClick={this.onClickReviewPublishChanges}
                    disabled={!this.hasStagedChanges()}
                  />
                )}
                { !this.props.readOnly && (
                  <Button
                    text="Add"
                    onClick={this.onAddChannelMapping}
                    icon="add-plus"
                    disabled={ !channelMappings.length }
                  />
                )}
                <Button
                  text="Download Data"
                  onClick={ () => this.onClickDownloadData(columnDefinitions, channelMappings) }
                  icon="download"
                  disabled={ !channelMappings.length }
                />
              </div>
            </div>
          }
          loadingText={ 'Loading channel mappings...' }
          loading={ channelMappings && !channelMappings.length }
          stickyHeader
        >
        <TablePropertyFiltering
          filteringOptions={getChannelMappingFilters(channelMappings)}
          groupValuesText="Values"
          groupPropertiesText="Properties"
          operationOrText="or"
          operationAndText="and"
          operationNotAndText="and not"
          operationNotOrText="or not"
          clearFiltersText="Clear filter"
          placeholder="Filter channel mappings"
          allowFreeTextFiltering={true}
        />
        <TableSorting
          sortingColumn="marketplaceId"
          sortableColumns={ [
            {id: 'cognosChannelType', field: 'cognosChannelType'},
            {id: 'cognosChannel', field: 'cognosChannel'},
            {id: 'groupCode', field: 'groupCode'},
            {id: 'excluded', field: 'excluded'},
            {id: 'hcpExcluded', field: 'hcpExcluded'},
            {id: 'hcpChannelType', field: 'hcpChannelType'},
            {id: 'hcpMerchantChannel', field: 'hcpMerchantChannel'},
            {id: 'marketplaceId', field: 'marketplaceId'},
            {id: 'marketplaceName', field: 'marketplaceName'},
          ] }
        />
        <TablePreferences title="Preferences" confirmLabel="Confirm" cancelLabel="Cancel">
          <TableContentSelector
            title="Select visible columns"
            options={ this.tableContentSelectorOptions(columnDefinitions) }
          />
        </TablePreferences>
        <TablePagination pageSize={ tablePageSize } />
        </Table>
        <CMReviewChanges
          {...reviewChangesScreen}
          modifiedChannelMappingsById={this.state.modifiedChannelMappingsById}
          originalChannelMappings={this.props.originalChannelMappings}
          stageChannelMappingChanges={this.stageChannelMappingChanges}
          unstageChannelMappingChanges={this.unstageChannelMappingChanges}
          publishChannelMappingChanges={this.publishChannelMappingChanges}
          onDismiss={this.reviewChangesScreenDismiss}
          errorScreenMessage={errorScreenMessage}
          successScreenMessage={successScreenMessage}
        />
        <CMAddMapping
          {...addMappingScreen}
          addChannelMappings={this.addChannelMappings}
          originalChannelMappings={this.state.channelMappings}
          onDismiss={this.addMappingScreenDismiss}
          dropdownOptions={this.props.dropdownOptions}
          hcpChannelOptions={this.props.hcpChannelOptions}
          errorScreenMessage={errorScreenMessage}
          successScreenMessage={successScreenMessage}
          marketplaceConfig={this.props.marketplaceConfig}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/channel_mapping_table.jsx